import { Bounce, toast, type ToastOptions } from 'react-toastify';

const ToastPosition: ToastOptions = {
	position: 'top-right',
	autoClose: 2000,
	hideProgressBar: true,
	closeOnClick: true,
	rtl: false,
	pauseOnFocusLoss: true,
	draggable: true,
	pauseOnHover: true,
	progress: undefined,
	theme: 'colored',
	transition: Bounce,
};

export const showToast = (type: 'success' | 'error' | 'info', message: string) => {
	switch (type) {
		case 'success':
			toast.success(message, ToastPosition);
			break;
		case 'error':
			toast.error(message, ToastPosition);
			break;
		case 'info':
			toast.info(message, ToastPosition);
			break;
		default:
			throw new Error(`Invalid toast type: ${type as string}`);
	}
};
